import { render } from "./EmployeeContractDetail.vue?vue&type=template&id=f2bd0056"
import script from "./EmployeeContractDetail.vue?vue&type=script&lang=js"
export * from "./EmployeeContractDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__